import { DisplayApiRequestBuilder } from '@/models/Common/DisplayApiRequestBuilder';
import { IDisplayEventListRequestParams } from '@/models/Display/Event/interfaces/IDisplayEventListRequestParams';
import DisplayEventListJSC from '@/schema/DisplayEventListJSC';
import { TReqConfigValidated } from '@/services/JSCService';
export default class DisplayEventRequestBuilder extends DisplayApiRequestBuilder {
  createGetEventListQuery(reqParams: IDisplayEventListRequestParams): TReqConfigValidated {
    return this.validate(DisplayEventListJSC, reqParams).map((params) => {
      return this.makeConfig('GET', '/board/v2/events', params);
    });
  }
}
